<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("companies.tabs.softwares") }}
      UiStack
        UiButton(
          variant="primary"
          @click="addSoftware"
          icon="Plus"
        ) {{ $t("actions.add") }}
        UiButton(
          v-if="basWareUploadButton"
          variant="primary"
          @click="uploadArchive"
          icon="FileUpload"
        ) {{ $t("companies.softwares.upload_learning_data") }}
        UiButton(
          v-if="basWareUploadButton"
          variant="primary"
          @click="forceLearning"
          icon="RefreshCw"
        ) {{ $t("companies.softwares.force_learning") }}
  UiCardSection
    RestTable(
      namespace="company_softwares"
      :headers="headers"
      ref="companySoftwaresTable"
      :fetch-handler="getData"
      :disablePagination="true"
      embed
    )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="showErrors(item)"
            v-if="item.has_errors"
            icon="AlertTriangle"
          ) {{ $t("companies.softwares.show_errors") }}
          UiButton(
            size="sm"
            variant="smooth-primary"
            @click="editSoftware(item)"
            icon="PencilCreate"
          ) {{ $t("actions.edit") }}
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="deleteSoftware(item)"
            icon="Trash"
          ) {{ $t("actions.delete") }}
  template(v-if="errors.length > 0")
    UiCardSection
      UiStack
        UiStackItem(fill)
        UiStackItem
          UiButton(
            size="sm"
            variant="smooth-primary"
            @click="hideErrors"
            icon="EyeNo"
          ) {{ $t("companies.softwares.hide_errors") }}
    UiCardSection
      DataTable(
        :embed="true"
        :progress="inProgress"
        :headers="errorsHeaders"
        :items="errors"
        ref="softwareErrorsTable"
        :disablePagination="true"
      )
  Storages(v-if="storages_show")
  CompanyApiKeys
  EditSoftwareModal(
    ref="EditSoftwareModal"
    @done="reloadList"
  )
  UploadLearningArchiveModal(ref="UploadLearningArchiveModal")
</template>

<script>
import router from "@/router";
import ApiCompanySoftwares from "@/api/companySoftwares.js";
import EditSoftwareModal from "@/modals/Companies/editSoftware.vue";
import UploadLearningArchiveModal from "@/modals/Companies/uploadLearingArchive.vue";
import ApiBaswareFiles from "@/api/basware_files.js";
import Storages from "@/views/Companies/Tabs/storages.vue";
import CompanyApiKeys from "@/views/Companies/apikeys.vue";

export default {
  components: {
    EditSoftwareModal,
    UploadLearningArchiveModal,
    Storages,
    CompanyApiKeys,
  },
  data() {
    return {
      inProgress: false,
      basWareUploadButton: false,
      errors: [],
      headers: [
        {
          key: "name",
          label: "Name",
          squeeze: false,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
      errorsHeaders: [
        {
          key: "error",
          label: "Error",
        },
        {
          key: "created_at",
          label: "Time",
        },
      ],
    };
  },
  computed: {
    storages_show() {
      return window.user.role !== "user";
    },
  },
  methods: {
    reloadList() {
      this.$refs.companySoftwaresTable.fetchData();
    },

    getData(params, config) {
      return ApiCompanySoftwares.fetchSoftwares(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        this.basWareUploadButton = resp.data.softwares.some(
          (s) => s.name === "Basware",
        );
        return {
          items: resp.data.softwares,
          meta: resp.data.meta,
        };
      });
    },

    addSoftware() {
      this.$refs.EditSoftwareModal.open(this.$route.params.id, null);
    },

    uploadArchive() {
      this.$refs.UploadLearningArchiveModal.open(this.$route.params.id);
    },

    forceLearning() {
      this.$dialogConfirm({
        title: this.$t("companies.softwares.force_learning"),
        description: this.$t("actions.basware_learning_description"),
        variant: "success",
        icon: "head-cog-outline",
        okLabel: this.$t("actions.ok"),
        okVariant: "success",
        okIcon: "Check",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiBaswareFiles.forceLearning(this.$route.params.id).then((resp) => {
          this.reloadList();
        });
      });
    },

    editSoftware(item) {
      this.$refs.EditSoftwareModal.open(this.$route.params.id, item);
    },

    deleteSoftware(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "lan-disconnect",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiCompanySoftwares.deleteSoftware(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },

    showErrors(item) {
      this.inProgress = true;
      ApiCompanySoftwares.fetchErrors(this.$route.params.id, item.id)
        .then((resp) => {
          this.errors = resp.data.errors;
          this.inProgress = false;
        })
        .catch((e) => {
          this.inProgress = false;
        });
    },

    hideErrors() {
      this.errors = [];
    },

    goBack() {
      router.push("/companies");
    },
  },
};
</script>
